import { render, staticRenderFns } from "./inicio.vue?vue&type=template&id=4a3d0230&scoped=true&"
import script from "./inicio.vue?vue&type=script&lang=js&"
export * from "./inicio.vue?vue&type=script&lang=js&"
import style0 from "./inicio.vue?vue&type=style&index=0&id=4a3d0230&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3d0230",
  null
  
)

export default component.exports